import {
  IonApp,
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react"
import {
  Editor,
  getSnapshot,
  Tldraw,
  TLUiOverrides,
  TLEventMapHandler,
  exportToBlob,
  TLPageId,
  ImageShapeUtil,
  ArrowBindingUtil,
  useEditor,
  defaultBindingUtils,
  defaultShapeUtils,
} from "tldraw"

import { useCallback, useEffect, useRef, useState } from "react"
import { DrawStrokeTool } from "../tools/DrawStrokeTool"
import { useAppDispatch, useAppSelector } from "../app/hooks"
import { useLocation, useParams } from "react-router"
import { DrawingId } from "../entities"
//import { StickerShapeUtil } from "../shapes/StickerShapeUtil"
import { throttle } from "tldraw"
import { EditableDrawingName } from "../components/EditableDrawingName"
import { SelectionOptions } from "../components/SelectionOptions"
import { InnerCanvas } from "../canvas-ui/InnerCanvas"

import { Title } from "../components/Title"
import { BucketTool } from "../tools/BucketTool"
import { CustomNudgeTool } from "../tools/CustomNudgeTool"
import { FillBindingUtil } from "../shapes/FillBindingUtil"
import { useCurrentPage } from "../hooks/useCurrentPage"
import { CustomDrawShapeProps } from "../../shared/CustomDrawShape"
import { LDPage } from "../../shared/LDPage"
import { Color, Expr } from "../../shared/Expr"
import { useHashParams } from "../hooks/useHashParams"
import { LDArrowTool } from "../tools/LDArrowTool"
import { TextTool } from "../tools/LDTextTool"
import { MarkerTool } from "../tools/MarkerTool"
import { MarkerShapeUtil } from "../shapes/MarkerShapeUtil"
import { LiveDraw } from "../LiveDraw"
import { Eraser } from "lucide-react"
import { EraserTool } from "../tools/ LDEraserTool"
import { DrawFillTool } from "../tools/DrawFillTool"
import { serializedInitialStore } from "../../shared/LDStore"
import { CustomDrawShapeUtil } from "../shapes/CustomDrawShapeUtil"
import { LDLineShapeUtil } from "../shapes/LDLineShapeUtil"
import { LDGroupShapeUtil } from "../shapes/LDGroupShapeUtil"
import { LDGeoShapeUtil } from "../shapes/LDGeoShapeUtil"

export function BlobViewer() {
  const [test, setTest] = useState(false)
  const dispatch = useAppDispatch()

  // initialize
  const { key } = useParams() as {
    key: string
  }
  const params = useHashParams()

  // console.log("params", params)
  // useEffect(() => {
  //   dispatch(loadBlob(key))
  // }, [])

  const editorBlob = useAppSelector((state) => state.app.editorBlob)
  console.log({ editorBlob })

  // const drawingsLookup = useAppSelector((state) => state.app.drawingsLookup)

  const editorRef = useRef<Editor | null>(null)

  useEffect(() => {
    const editor = editorRef.current
    if (!editor) return
    const targetPage = editor.getPage(editorBlob!.pageId) as LDPage
    const pageMeta = targetPage!.meta
    const pageParams = {
      ...pageMeta.parameters,
      ...Object.fromEntries(
        Object.keys(params).map((paramId) => {
          const paramValue = params[paramId]
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return [
            paramId,
            { type: "color", defaultValue: (paramValue as any).value },
          ]
        }),
      ),
    }

    editor.updatePage({
      id: editorBlob!.pageId,
      meta: {
        ...targetPage!.meta,
        parameters: pageParams,
      },
    })
  }, [params])

  function handleTldrawMount(editor: Editor) {
    // get the stored current page id
    const currentPageId = editor.getDocumentSettings().meta
      .currentPageId as TLPageId

    // window['editor'] = editor

    console.log({ editorBlob })

    // apply the stored current page id
    editorBlob && editor.setCurrentPage(editorBlob.pageId)

    editor.updateInstanceState({
      isGridMode: true,
    })
    editor.setCurrentTool("select")

    const targetPage = editor.getPage(editorBlob!.pageId) as LDPage

    const pageMeta = targetPage!.meta
    const pageParams = {
      ...pageMeta.parameters,
      ...Object.fromEntries(
        Object.keys(params).map((paramId) => {
          const paramValue = params[paramId]
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return [
            paramId,
            { type: "color", defaultValue: (paramValue as any).value },
          ]
        }),
      ),
    }

    editor.updatePage({
      id: editorBlob!.pageId,
      meta: {
        ...targetPage!.meta,
        parameters: pageParams,
      },
    })

    // editor.updatePage({
    //   id: editor.getCurrentPageId(),
    //   meta: /*editor.getCurrentPage().meta ??*/ Page.initial,
    // }) netlify test

    // editor.createShapes([
    //   ({
    //     id: 'shape:0' as TLShapeId,
    //     type: 'custom-draw',
    //     props: {
    //       isComplete: true,
    //       isClosed: false,
    //       isPen: false,
    //       segments: [
    //         {
    //           type: 'free',
    //           points: [{ x: 10, y: 20 }, { x: 50, y: 450 }, { x: 350, y: 350 }]
    //         } as TLDrawShapeSegment,
    //       ],
    //       scale: 1,
    //       layer: '0',
    //     } as CustomDrawShapeProps
    //   }),
    // ])

    editorRef.current = editor
    // //console.log(editor)

    // editor.store.listen(
    //   (update) => {
    //     //console.log('update', update)
    //   },
    //   { scope: 'document', source: 'user' }
    // )

    // only subscribe to changes to the document

    // editor.updateShapes([

    // ])
  }
  if (!editorBlob || !editorBlob.pageId) {
    return (
      <IonPage>
        <div>Loading...</div>
      </IonPage>
    )
  }

  return (
    <IonPage>
      <Tldraw
        snapshot={editorBlob?.data ?? serializedInitialStore}
        // snapshot={{
        //   document: editorDrawing?.data ?? serializedInitialStore,
        //   session: {
        //     version: 0,
        //   },
        // }}
        // initialData={}
        onMount={handleTldrawMount}
        bindingUtils={[...defaultBindingUtils, FillBindingUtil]}
        shapeUtils={[
          ...defaultShapeUtils,
          CustomDrawShapeUtil,
          LDLineShapeUtil,
          LDGroupShapeUtil,
          LDGeoShapeUtil,
          MarkerShapeUtil,
        ]}
        // overrides={overrides}
        initialState="draw-stroke"
        tools={[
          DrawStrokeTool,
          BucketTool,
          CustomNudgeTool,
          LDArrowTool,
          TextTool,
          MarkerTool,
          EraserTool,
          DrawFillTool,
        ]}
        // hideUi
        components={{
          Toolbar: null,
          MainMenu: null,
          PageMenu: null,
          // Cursor: CustomCursor,
          // removes the "Exit pen mode" button that shows up after using the pen
          HelperButtons: null,
          // will pan with the canvas but won't be affected by zoom
          InFrontOfTheCanvas: () => {
            return null // return <SelectionOptions />
          },
        }}
        forceMobile
      ></Tldraw>
    </IonPage>
  )
}
